import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Location } from "history";
import _ from "underscore";

import { apiPromiseHook } from "../../../../shared/flux/actions/enterHooks";
import { GoogleAnalyticsHelper } from "@travellocal/ui";
import { EnterHookPromises } from "../../../state/enterHookPromises";
import { LocationImageGalleryDialog } from "./../../../../shared/components/locationImageGalleryDialog";
import * as WebRoutes from "@travellocal/utils/webRoutes";

interface OwnProps {
  location: Location;
}

interface StateProps {
  currentLocationImage: IState<IAccomodationLocationImage>;
  country: IState<ILocation>;
}

interface DispatchProps {
  backToGallery: (countrySlug: string, regionSlug: string) => void;
  imageClicked: (countrySlug: string, fileName: string, regionSlug: string) => void;
}

type Props = OwnProps & DispatchProps & StateProps;

export class CountryGalleryDialogComponent extends React.Component<Props, {}> {
  private onGalleryClose(countrySlug: string, regionSlug: string): void {
    GoogleAnalyticsHelper.logEvent("Image Gallery", "Click", "Close Gallery");
    this.props.backToGallery(countrySlug, regionSlug);
  }
  public render() {
    const country = this.props.country.data;
    const { pathname } = this.props.location;
    const fileName = _.last((pathname as string).split("/"));
    const dedupedImages = country.images.filter(image => !image.locationImageType);
    return (
      <div>
        {this.props.currentLocationImage.data &&
          <Helmet title={this.props.currentLocationImage.data.meta}
            meta={[
              { name: "description", content: this.props.currentLocationImage.data.description },
            ]}
          />
        }

        <LocationImageGalleryDialog
          isOpen={true}
          selectedImageFileName={fileName}
          onGalleryClosed={() => this.onGalleryClose(country.slug, country.parent.slug)}
          prevClicked={(im) => this.props.imageClicked(country.slug, im.fileName, country.parent.slug)}
          nextClicked={(im) => this.props.imageClicked(country.slug, im.fileName, country.parent.slug)}
          imageClicked={(im) => this.props.imageClicked(country.slug, im.fileName, country.parent.slug)}
          title={`${country.name} gallery`}
          images={dedupedImages} />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch): DispatchProps => {
  return {
    backToGallery:
      (countrySlug: string, regionSlug: string) => dispatch(push(WebRoutes.countryGallery(countrySlug, regionSlug))),
    imageClicked:
      (countrySlug: string, fileName: string, regionSlug: string) =>
        dispatch(push(WebRoutes.countryGalleryImage(countrySlug, fileName, regionSlug))),
  };
};

const mapStateToProps = (state: IWebStoreState): StateProps => {
  return {
    country: state.country,
    currentLocationImage: state.currentLocationImage,
  };
};

export const GalleryDialog = connect(mapStateToProps, mapDispatchToProps)(CountryGalleryDialogComponent);

export const galleryDialogOnEnter = apiPromiseHook<unknown>(EnterHookPromises.imageByFileName("fileName"));
